import { Table, Button } from 'antd';
import React, { Component } from 'react';
import { columns5 } from './data';

class index extends Component {
    render() {
        const { data, print, onExport } = this.props;
        return (
            <div>
                <div className="table-title">Special Restaurant Key Performance Indicator 特色餐厅关键绩效指数</div>
                <Table
                    columns={columns5()}
                    dataSource={data.data5}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    id="table5_10_5"
                    scroll={print ? {} : { x: 3350, y: false }}
                    rowKey={v => v.sort}
                />
                {print ? null : <Button
                    className='export-btn'
                    type="primary"
                    onClick={() => onExport('table5_10_5', 'Special Restaurant Key Performance Indicator 特色餐厅关键绩效指数')}
                    loading={print}
                >导出Excel</Button>}
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/Table5_10_5.js